var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMicOffWhiteIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4959 7.06833L12.4993 5C12.4993 3.61667 11.3827 2.5 9.99935 2.5C8.61602 2.5 7.49935 3.61667 7.49935 5V10C7.49935 10.5805 7.69598 11.114 8.02644 11.5378L12.4959 7.06833ZM12.493 8.83905L9.02721 12.3048C9.32588 12.4305 9.65432 12.5 9.99935 12.5C11.3827 12.5 12.491 11.3833 12.491 10L12.493 8.83905ZM6.7135 12.8507C6.02018 12.1182 5.58268 11.1366 5.58268 10H4.16602C4.16602 11.4768 4.77466 12.8172 5.74149 13.8227L6.7135 12.8507ZM6.70064 14.6314L7.70138 13.6306C8.38614 14.0285 9.18114 14.25 9.99935 14.25C12.2993 14.25 14.416 12.5 14.416 10H15.8327C15.8327 12.85 13.566 15.2 10.8327 15.6V18.3333H9.16602V15.6C8.27359 15.4667 7.43092 15.1273 6.70064 14.6314Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7338 1.82999L1.82387 17.7399L0.498047 16.4141L16.4079 0.50416L17.7338 1.82999Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMicOffWhiteIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mic-off-white-icon.2d0d7954.svg";
export { ForwardRef as ReactComponent };